import axios from "axios";

import {
  SET_INITIAL_USER_TOKEN,
  ERROR_SET_INITIAL_USER_TOKEN,
  CHANGE_USER_TOKEN_AND_CURRENT_WORKSPACE,
} from "./actionTypes";

import { LOGIN } from "../constants/urls";
import { checkUserRights } from "./userActions";

export function changeUserTokenAndCurrentWorkspace(
  userToken,
  currentWorkspace
) {
  return {
    type: CHANGE_USER_TOKEN_AND_CURRENT_WORKSPACE,
    userToken,
    currentWorkspace,
  };
}

export function setInitialUserToken(userToken) {
  return {
    type: SET_INITIAL_USER_TOKEN,
    userToken,
  };
}

export function errorHappenedDuringSettingOfUserToken() {
  return {
    type: ERROR_SET_INITIAL_USER_TOKEN,
  };
}

export function getInitialUserToken() {
  return (dispatch) => {
    axios({
      url: LOGIN,
      params: {
        username: "public user",
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    })
      .then((response) => {
        dispatch(setInitialUserToken(response.data.RegHub_response.USER_TOKEN));
        dispatch(checkUserRights(response.data.RegHub_response.USER_TOKEN));
      })
      .catch((err) => {
        //window.alert("Error occurred" + err);
        dispatch(
          errorHappenedDuringSettingOfUserToken(
            err.response ? err.response.data : err
          )
        );
      });
  };
}
